import React from "react";
import { IAccessesData } from "../../common/controls/AccessRelationControl";
import { IAuthorizationsData } from "../../common/controls/AuthorizationRelationControl";
import { ILogPlusResourcesData } from "../../common/controls/LogPlus/IModels";
import { IPersonProfileRelationsData } from "../controls/PersonProfileRelations/PersonProfileRelationsControl";

export interface IIssueWorkflowData {
	LogPlusPersons?: ILogPlusResourcesData;
	LogPlusItSystems?: ILogPlusResourcesData,
	LogPlusDevices?: ILogPlusResourcesData,
	LogPlusAgreements?: ILogPlusResourcesData,
	LogPlusLicenses?: ILogPlusResourcesData,
	LogPlusServices?: ILogPlusResourcesData,

	'PersonProfiles.Value'?: IPersonProfileRelationsData,
	'Accesses.Value'?: IAccessesData,
	'Authorizations.Value'?: IAuthorizationsData,

	Notifier?: {value: string, label: string}
}

export interface IWorkflowContext {
	isTransient: boolean,
	issueWorkflowData: IIssueWorkflowData,
	setIssueWorkflowData: (d: IIssueWorkflowData) => void,
	setIssueWorkflowDataByName: (propertName: string, value: any) => void,
}

const defaultValue: IWorkflowContext = {
	isTransient: null,
	issueWorkflowData: { },
	setIssueWorkflowData: (data) => { },
	setIssueWorkflowDataByName: (propertName, value) => { },
};

export const WorkflowContext = React.createContext(defaultValue);